module.exports = __webpack_public_path__ + "pnskfsquadron/img/ico.png?726d6269";